import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { ICategory } from "./categories.interface";
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../../shared/services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class CategoriesService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getCategories(filter?: any): Observable<any> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_CATEGORIES)}${queryParams}`);
  }

  getCategory(category: ICategory | string): Observable<any> {
    let id = (typeof category == 'string') ? category : category._id;
    return this._http.get(`${apiURL(EnvConfig.API_CATEGORIES)}/${id}`);
  }

  createCategory(category: ICategory): Observable<any> {
    return this._http.post(`${apiURL(EnvConfig.API_CATEGORIES)}`, category);
  }

  updateCategory(category: ICategory): Observable<any> {
    let id = category._id;
    delete category._id;
    return this._http.patch(`${apiURL(EnvConfig.API_CATEGORIES)}/${id}`, category);
  }

  deleteCategory(category: ICategory | string, hardDelete: boolean = false): Observable<void> {
    let id = (typeof category == 'string') ? category : category._id;
    if (hardDelete) return this._http.delete(`${apiURL(EnvConfig.API_CATEGORIES)}/${id}`);
    return this._http.delete(`${apiURL(EnvConfig.API_CATEGORIES)}/${id}/delete`);
  }

  restoreCategory(category: ICategory | string): Observable<void> {
    let id = (typeof category == 'string') ? category : category._id;
    return this._http.post(`${apiURL(EnvConfig.API_CATEGORIES)}/${id}/restore`, null);
  }
}